import moment from "moment";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import Header from "../../../components/Headers/Header";
import CustomTable from "../../../components/Tables/CustomTable";
import { ISelectedFilters } from "../../../types";
import Filter from "../Components/Filter/Filter";
import HeaderWithDownload from "../../../components/HeaderWithDownload";

export default function MonthlyStudentContentProgress() {
  const session = useSelector((state: any) => state.user.session);
  const [selectedFilters, setSelectedFilters] = useState<ISelectedFilters>();
  const [selectedFilterForReport, setSelectedFilterForReport] =
    useState<ISelectedFilters>();
  return (
    <React.Fragment>
      <Header />
      <Container className="mt-n7" fluid>
        <Card className="mb-4 mb-xl-0">
          <CardHeader className="border-0">
            <HeaderWithDownload
              title="Student Monthly Content
                Progress"
              reportType="contentProgress"
              selectedFilters={selectedFilterForReport}
            />
            <div className="pt-2">
              <Filter
                hasDistrictFilter
                hasBlockFilter
                hasSchoolFilter
                hasGradeFilter
                onSearch={(value) => {
                  setSelectedFilters(value);
                }}
                onClear={() => {
                  setSelectedFilters(undefined);
                }}
                onFilterChange={(value) =>
                  setSelectedFilterForReport({
                    ...value,
                    date: {
                      start_date: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                      end_date: moment().add(1, "d").format("YYYY-MM-DD"),
                    },
                  })
                }
              />
            </div>
          </CardHeader>

          <CardBody>
            <CustomTable
              url={`custom/stats_admin/student/contentUsage?grade_id=${
                selectedFilters?.gradeId || -1
              }&student_id=-1&grade_section_id=-1&district=${
                selectedFilters?.districtId || -1
              }&block=${selectedFilters?.blockId || -1}&school=${
                selectedFilters?.schoolId || -1
              }&start_date=${moment()
                .subtract("30", "days")
                .format("YYYY-MM-DD")}&end_date=${moment()
                .add(1, "d")
                .format("YYYY-MM-DD")}&limit=${10}&session=${session?.id}`}
              column={[
                { key: "srn_no", label: "SRN No." },
                { key: "first_name", label: "First name" },
                { key: "last_name", label: "Last name" },
                { key: "grade", label: "Grade" },
                { key: "section", label: "Section" },
                { key: "school", label: "School" },
                { key: "district", label: "District" },
              ]}
              tableTitle={""}
              searchBox={false}
              itemsLimit={10}
              customFunction={() => {}}
              customColumns={[
                {
                  heading: "Material watched(%)",
                  renderer: (each: any) => {
                    return (
                      <span>{`${each?.material_consumption || 0} %`}</span>
                    );
                  },
                },
                {
                  heading: "Time spent (hh:mm)",
                  renderer: (each: any) => {
                    return (
                      <span>{`${Math.floor(+each?.time_spent / 60)}:${
                        +each?.time_spent % 60
                      }`}</span>
                    );
                  },
                },
                {
                  heading: "Material watched",
                  renderer: (each: any) => {
                    return (
                      <span>{`${each?.watched_material} of ${each?.total_material}`}</span>
                    );
                  },
                },
              ]}
            />
          </CardBody>
        </Card>
      </Container>
    </React.Fragment>
  );
}
